import { render } from "./OrderTestTabLabel.vue?vue&type=template&id=66d1ae3e&scoped=true"
import script from "./OrderTestTabLabel.vue?vue&type=script&lang=js"
export * from "./OrderTestTabLabel.vue?vue&type=script&lang=js"

import "./OrderTestTabLabel.vue?vue&type=style&index=0&id=66d1ae3e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d1ae3e"]])

export default __exports__